<script lang="ts">
    import { _ } from "svelte-i18n"
    import { overlay } from "../../../store"
    import { login, LoginError, postLogin, postLogout } from "../../../functionTools/login"
    import FormInputText from "../../widgets/Form/FormInputText.svelte"
    import BarLoader from "svelte-loading-spinners/BarLoader.svelte"
    import { einfoApiUrl } from "../../../../../api/hooks/config-client"
    import { checkoutData } from "../../../functionTools/cart"

    let loading = false
    let error: any
    let invalid = false
    let noOrderPermission = false

    let _dealerLogin = {
        number: "",
        pass: "",
    }
    let mfaToken = ""
    let mfaCode = ""

    const doLogin = async () => {
        loading = true
        invalid = false
        error = undefined
        noOrderPermission = false
        try {
            const l = await postLogin({ username: _dealerLogin.number, password: _dealerLogin.pass, mfaToken, mfaCode })
            _dealerLogin.number = ""
            _dealerLogin.pass = ""
            mfaToken = ""
            if (l?.account?.email) {
                $checkoutData.contact.email = l.account.email
            }
        } catch (e: unknown) {
            const loginError = e as LoginError
            if (loginError.type == "no_order_permission") {
                noOrderPermission = true
                _dealerLogin.number = ""
                _dealerLogin.pass = ""
                mfaToken = ""
            } else if (loginError.type == "mfa") {
                // mfa required
                _dealerLogin.number = ""
                _dealerLogin.pass = ""
                mfaToken = loginError.data?.mfaToken
            } else {
                invalid = true
                error = e
                mfaToken = ""
            }
            console.log(e)
        }
        loading = false
    }
</script>

<div class="headline">{$_("dealer-login.headline")}</div>

{#if $login}
    <p>
        {@html $_("dealer-login.logged-in-info-html", {
            values: {
                number: $login?.account?.ident?.dealerNumber + "-" + $login?.account?.ident?.personNumber,
            },
        })}
    </p>
    <button
        class="button primary"
        onclick={() => {
            postLogout()
                .then(() => {
                    window.setTimeout(() => {
                        $overlay.show = false
                    }, 500)
                })
                .catch((e: any) => {
                    console.error(e)
                })
        }}>{$_("dealer-login.logout")}</button
    >
{:else}
    <form
        onsubmit={(e) => {
            e.preventDefault()
            e.stopPropagation()
            doLogin()
        }}
    >
        {#if mfaToken}
            <p>{$_("dealer-login.mfa-info")}</p>
            <FormInputText
                type="text"
                name="mfaCode"
                label={$_("dealer-login.mfa-code")}
                bind:value={mfaCode}
                required
            />
        {:else}
            <FormInputText
                type="text"
                name="number"
                label={$_("dealer-login.dealer-number")}
                bind:value={_dealerLogin.number}
                required
            />
            <FormInputText
                name="password"
                label={$_("dealer-login.password")}
                bind:value={_dealerLogin.pass}
                type="password"
                required
                class="sentry-mask"
            />
        {/if}

        {#if noOrderPermission}
            <p style="color: var(--error)">{$_("dealer-login.no-permission")}</p>
        {:else}
            {#if error}
                <p style="color: var(--error);">
                    {$_("dealer-login.error")}
                </p>
            {/if}

            {#if invalid}
                <p style="color: var(--error)">{$_("dealer-login.invalid-login")}</p>
            {/if}
        {/if}

        {#if loading}
            <BarLoader />
        {:else}
            <div class="row">
                <div class="col-md-6">
                    <a href="{einfoApiUrl.replace('/api/', '')}/de/account-pw-reset" target="_blank"
                        >{$_("dealer-login.forgot-password")}</a
                    >
                </div>
                <div class="col-md-6" style="text-align: right;">
                    <button class="button primary" type="submit">{$_("dealer-login.login")}</button>
                </div>
            </div>
        {/if}
    </form>

    <br />

    <div class="headline">{$_("dealer-login.no-einfo-login")}</div>
    <p>
        {$_("dealer-login.use-following-portal")}
        <br />

        <a href="{einfoApiUrl.replace('/api/', '')}/de/account-request?ref=eShop" target="_blank">
            {$_("dealer-login.to-einfo-register")}
        </a>
        <br />
        <br />
    </p>
    <p>
        {@html $_("dealer-login.problem-contact-html")}
    </p>
{/if}

<style lang="less">
    form {
        margin-bottom: 20px;
    }
    .headline {
        font-weight: 800;
        margin-bottom: 20px;
    }
</style>
